module.exports = __webpack_public_path__ + "static/img/statement_receipt.1270c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/statement_receipt.png
// module id = 466I
// module chunks = 0